import React from "react";
import PropTypes from "prop-types";
import { Show } from "@edreamsodigeo/frontend-core";
import { BackgroundImage, Box, Flex } from "@edreamsodigeo/prisma-design-system";
const CardWithBackgroundImage = ({
  title,
  description,
  cta,
  backgroundImage,
  backgroundColor,
  backgroundPosition = "right bottom",
  backgroundSize = "auto",
  boxPaddingDesktop = "1x_big",
  boxPaddingBottomMobile = "1x_big",
  sx
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    height: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: backgroundColor,
    height: "100%",
    width: "100%",
    position: "absolute",
    sx: sx
  }), /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    position: "relative"
  }, /*#__PURE__*/React.createElement(BackgroundImage, {
    backgroundImage: `url('${backgroundImage}')`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: backgroundPosition,
    sx: {
      backgroundSize: backgroundSize
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: ["big", boxPaddingDesktop],
    pb: [boxPaddingBottomMobile, boxPaddingDesktop]
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, null, title), /*#__PURE__*/React.createElement(Box, {
    pt: "1x_small"
  }, description), /*#__PURE__*/React.createElement(Show, {
    when: !!cta
  }, /*#__PURE__*/React.createElement(Box, {
    pt: "base"
  }, cta))), /*#__PURE__*/React.createElement(Box, {
    minWidth: "30%"
  }))))));
};
export default CardWithBackgroundImage;
CardWithBackgroundImage.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  cta: PropTypes.node,
  backgroundImage: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundPosition: PropTypes.string,
  backgroundSize: PropTypes.string
};